import React from 'react';
import styles from './SelectedMembersList.scss';
import { InjectedTranslateProps, translate } from 'react-i18next';

import { connect } from 'react-redux';
import { primaryColorOrDefault } from '../../../reducers';
import { SiteMember } from '../ChatCreation';
import { AVATARS } from '../../../constants/avatars';
import ButtonPic from '../../ButtonPic/ButtonPic';

interface SelectedMembersListProps extends InjectedTranslateProps {
  numberOfMemberToPresent: number;
  numberOfMemberToScroll: number;
  selectedMembers: SiteMember[];
  onClickOnMember: Function;
  primaryColor: string;
}

const mapStateToProps = (state) => ({
  primaryColor: primaryColorOrDefault(state),
});

interface SelectedMembersListState {
  firstElementShow: number;
}

class SelectedMembersList extends React.Component<
  SelectedMembersListProps,
  SelectedMembersListState
> {
  constructor(props: SelectedMembersListProps) {
    super(props);

    this.state = {
      firstElementShow: 0,
    };
  }

  handleMemberListNavigationRightClicked = () => {
    this.setState({
      firstElementShow:
        this.state.firstElementShow + this.props.numberOfMemberToScroll,
    });
  };

  handleMemberListNavigationLeftClicked = () => {
    this.setState({
      firstElementShow:
        this.state.firstElementShow - this.props.numberOfMemberToScroll,
    });
  };

  renderSelectedMembers = ({ userId, name, image }: SiteMember) => {
    const avatar =
      image && image.url
        ? { ...AVATARS.IMG.prop, imgUrl: image.url }
        : AVATARS.NONE.prop;

    return (
      <div className={styles.selectedMembersViewButton} key={userId}>
        <ButtonPic
          onClick={async () => {
            await this.handleSelectedMembersView(userId);
          }}
          dataHook={'selected-member-button'}
          avatar={avatar}
        >
          {name}
        </ButtonPic>
      </div>
    );
  };

  handleSelectedMembersView = async (userId) =>
    this.props.onClickOnMember(userId);

  render() {
    const { selectedMembers, numberOfMemberToPresent } = this.props;
    const { firstElementShow } = this.state;

    if (selectedMembers.length <= 0) {
      return null;
    }

    return (
      <div
        className={styles.selectedMembersView}
        data-hook="selected-members-view"
      >
        <div className={styles.selectedMembersLeft}>
          {firstElementShow > 0 && (
            <button
              className={styles.selectedMembersLeftButton}
              data-hook="member-navigation-button-left"
              onClick={this.handleMemberListNavigationLeftClicked}
            />
          )}
        </div>
        <div className={styles.selectedMembersViewList}>
          {selectedMembers
            .filter(
              (item, index) =>
                index >= firstElementShow &&
                index < firstElementShow + numberOfMemberToPresent,
            )
            .map(this.renderSelectedMembers)}
        </div>
        <div className={styles.selectedMembersRight}>
          {selectedMembers.length - firstElementShow >
            numberOfMemberToPresent && (
            <button
              className={styles.selectedMembersRightButton}
              data-hook="member-navigation-button-right"
              onClick={this.handleMemberListNavigationRightClicked}
            />
          )}
        </div>
      </div>
    );
  }
}

export default translate()(connect(mapStateToProps)(SelectedMembersList));
